import { render, staticRenderFns } from "./review-item.vue?vue&type=template&id=629e6667"
import script from "./review-item.vue?vue&type=script&lang=js"
export * from "./review-item.vue?vue&type=script&lang=js"
import style0 from "./review-item.vue?vue&type=style&index=0&id=629e6667&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Avatar: require('/app/components/ui/Avatar.vue').default})
